import { env } from 'next-runtime-env'

export const getAdConfig = () => {
  return {
    isGoogleAdEnabled: env('NEXT_PUBLIC_ENABLE_GOOGLE_AD') === 'true',
    googleAdEnabledTags: (env('NEXT_PUBLIC_GOOGLE_AD_ENABLED_TAGS') || '')
      .split('|')
      .filter(Boolean),
    googleAdClientId: env('NEXT_PUBLIC_GOOGLE_AD_CLIENT'),
    googleAdSlotId: env('NEXT_PUBLIC_GOOGLE_AD_SLOT'),
  }
}

export const isGoogleAdEnabledByGenre = (genres: string[] | undefined): boolean => {
  if (!Array.isArray(genres) || genres.length === 0) return false

  const { googleAdEnabledTags } = getAdConfig()
  if (googleAdEnabledTags.length === 0) return false

  return genres.some((genre) => googleAdEnabledTags.includes(genre))
}
